
    // this file was auto generated by python script
    import Figma from './Figma';
    export default Figma;
    